<template>
  <div>
    <Breadcrumbs title="Search part" main="Catalog"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <form @submit.prevent="prepareSearchPart">
                    <div class="input-group">
                      <input class="form-control" placeholder="Part number" v-model="partNumber">
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="submit">Search</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="loaded || loadingProcess">
          <div class="card" v-if="currentStep === 'selectCar'">
            <div class="card-header">
              <h5 class="card-title mb-0">Cars</h5>
              <span>Cars with this part number, please select one car</span>
            </div>
            <div class="col-md-12" v-if="loadingProcess">
              <div class="lds-facebook">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="table-responsive mb-0" style="max-height: 600px;" v-if="!loadingProcess">
              <table role="table" aria-busy="false" aria-colcount="4"
                     class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                <thead role="rowgroup" class=""><!---->
                <tr role="row" class="">
                  <th role="columnheader" scope="col">
                    <div>Image</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>VIN</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Mark</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Model</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Prod date</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>View</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Serial number</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Body</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Engine</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Type</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Catalyst</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>St. wheel</div>
                  </th>
                  <th role="columnheader" scope="col">
                    <div>Transmission</div>
                  </th>
                </tr>
                </thead>
                <tbody role="rowgroup">
                <tr role="row" class="" style="cursor: pointer" v-for="(car, index) in cars" :key="index"
                    @click.prevent="selectCar(car)">
                  <td><img :src="car.car_img" alt=""></td>
                  <td>{{ car.car_vin }}</td>
                  <td>{{ car.car_mark }}</td>
                  <td>{{ car.car_model }}</td>
                  <td>{{ car.car_prod_date }}</td>
                  <td>{{ car.car_view }}</td>
                  <td>{{ car.car_serial_number }}</td>
                  <td>{{ car.car_body }}</td>
                  <td>{{ car.car_engine }}</td>
                  <td>{{ car.car_type }}</td>
                  <td>{{ car.car_catalyst }}</td>
                  <td>{{ car.car_steering_wheel }}</td>
                  <td>{{ car.car_transmission }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="btn btn-info" @click="loadNextPage" v-show="cars.length">Load next page</div>
          </div>

          <div v-if="currentStep === 'selectScheme'">
            <div class="btn btn-info mb-3" @click="backToCars">Back to cars</div>

            <div class="card">
              <div class="card-header">
                <h5 class="card-title mb-0">Schemes</h5>
                <span>Schemes with this part number, please select one scheme</span>
              </div>
              <div class="col-md-12" v-if="loadingProcess">
                <div class="lds-facebook">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div class="table-responsive mb-0" v-if="!loadingProcess">
                <table role="table" aria-busy="false" aria-colcount="4"
                       class="table b-table table-de table-striped table-hover" id="__BVID__497"><!----><!---->
                  <thead role="rowgroup" class=""><!---->
                  <tr role="row" class="">
                    <th role="columnheader" scope="col">
                      <div>Image</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Scheme</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Description</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>From</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>To</div>
                    </th>
                    <th role="columnheader" scope="col" style="width: 100px;">
                      <div>Markets</div>
                    </th>
                    <th role="columnheader" scope="col">
                      <div>Inrormation</div>
                    </th>
                  </tr>
                  </thead>
                  <tbody role="rowgroup">
                  <tr role="row" class="" style="cursor: pointer" v-for="(scheme, index) in schemes" :key="index"
                      @click.prevent="selectScheme(scheme)">
                    <td><img :src="scheme.img_small" alt="" style="width: 150px;"></td>
                    <td>{{ scheme.id }}</td>
                    <td>{{ scheme.description }}</td>
                    <td>{{ scheme.from }}</td>
                    <td>{{ scheme.to }}</td>
                    <td style="width: 200px;word-break: break-word;">{{ scheme.markets }}</td>
                    <td>{{ scheme.comment }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="currentStep === 'schemeDetail'">
            <div class="btn btn-info mb-3" @click="backToSchemes">Back to schemes</div>

            <div class="row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header">
                    <h5>Scheme</h5>
                  </div>
                  <div class="card-body">
                    <img :src="selectedScheme.img_big" alt="" class="img-thumbnail">
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h5 class="card-title mb-0">Diagram parts list</h5>
                <span>All parts in this diagram, found part is highlighted in color</span>
              </div>
              <div class="table-responsive mb-0">
                <table role="table" aria-busy="false" aria-colcount="4"
                       class="table b-table table-striped table-hover" id="__BVID__497"><!----><!---->
                  <thead role="rowgroup" class=""><!---->
                  <tr role="row" class="">
                    <th>Position</th>
                    <th>Part Number</th>
                    <th style="min-width:25%">Description</th>
                    <th>Supplement</th>
                    <th>Quantity</th>
                    <th>Effective-in date</th>
                    <th>Expiration date</th>
                    <th>Steering</th>
                    <th title="A - Replacement / E - Cancellation code" class="title_ico">A/E</th>
                    <th>Returnable</th>
                  </tr>
                  </thead>
                  <tbody role="rowgroup">
                  <tr role="row" class="" v-for="(partInScheme, index) in selectedScheme.compatibility" :key="index"
                      :class="{ 'bg-info': partInScheme.part_number === partNumber }">
                    <td>{{ partInScheme.position }}</td>
                    <td>{{ partInScheme.part_number }}</td>
                    <td>{{ partInScheme.description }}</td>
                    <td>{{ partInScheme.supplement }}</td>
                    <td>{{ partInScheme.quantity }}</td>
                    <td>{{ partInScheme.effective }}</td>
                    <td>{{ partInScheme.expiration }}</td>
                    <td>{{ partInScheme.steering }}</td>
                    <td>{{ partInScheme.replacement }}</td>
                    <td>{{ partInScheme.returnable }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import {partService} from '../../_services';

export default {
  data: function () {
    return {
      loadingProcess: false,
      loaded: false,
      partNumber: null,
      cars: {},
      part: {},
      selectedCar: {},
      selectedScheme: {},
      schemes: {},
      currentStep: 'selectCar'
    };
  },
  created() {
    if (this.$route.query.part_number) {
      this.partNumber = this.$route.query.part_number;
      this.searchPart();
    }
  },
  methods: {
    backToCars() {
      this.currentStep = 'selectCar';
      this.selectedCar = {};
    },
    backToSchemes() {
      this.currentStep = 'selectScheme';
      this.selectedScheme = {};
    },
    selectCar(car) {
      this.selectedCar = car;
      this.currentStep = 'selectScheme';

      this.searchSchemes(this.partNumber, car.car_type_id);
    },
    selectScheme(scheme) {
      this.selectedScheme = scheme;
      this.currentStep = 'schemeDetail';
    },
    loadNextPage() {
      this.$router.push({
        path: '/catalog/search-part', query: {
          part_number: this.partNumber,
          limit: 25,
          offset: parseInt(this.$route.query.offset) + 25
        }
      });

      this.searchPart();
    },
    prepareSearchPart() {
      this.$router.push({
        path: '/catalog/search-part', query: {
          part_number: this.partNumber,
          limit: 25,
          offset: 0
        }
      });

      this.currentStep = 'selectCar';
      this.selectedCar = {};
      this.selectedScheme = {};
      this.schemes = {};

      this.searchPart();
    },
    searchPart() {
      this.loadingProcess = true;

      partService.searchPart(
          this.$route.query.part_number,
          this.$route.query.limit,
          this.$route.query.offset
      )
          .then(
              async response => {
                this.cars = response.data.cars;
                this.part = response.data.part;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    searchSchemes(partNumber, carTypeId) {
      this.loadingProcess = true;

      partService.searchSchemes(
          partNumber,
          carTypeId
      )
          .then(
              async response => {
                this.schemes = response.data.schemes;
                this.loaded = true;
                this.loadingProcess = false;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    }
  },
}
</script>
